export default {
    'hoursShort': {
        ru: 'ч',
        en: 'h',
    },
    'minutesShort': {
        ru: 'м',
        en: 'm',
    },
}